import { useHistory } from 'react-router-dom';
import { Loading } from '@betrybe/ada-react';

import { useClient } from '@/hooks';
import { StatesEnum } from '@/utils';
import { DefaultLayout } from '@/layouts';

const FifteenDelayDisapproval: React.FC = () => {
  const history = useHistory();
  const { currentState } = useClient();

  if (currentState === StatesEnum.SCORE_DISAPPROVED) {
    history.push('/register/guarantors');
    return <Loading>Aguarde...</Loading>;
  }

  return (
    <DefaultLayout cardSize="normal-card">
      <div className="disapproval-container">
        <div className="disapproval-container__texts">
          <h1>Não foi dessa vez :(</h1>

          <p>
            Agradecemos seu interesse em optar por este método de pagamento para
            estudar na Trybe, mas sua análise de crédito não foi aprovada.
          </p>

          <p>
            Esperamos poder te oferecer outras oportunidades como esta em breve!
          </p>
        </div>

        <div className="disapproval-container__image">
          <img
            src="/assets/images/disapproval.svg"
            alt="Imagem de reprovação dos dados pessoais"
          />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default FifteenDelayDisapproval;
